'use strict';
import {settings} from '../../../variables.js'
var apiBaseUrl = settings.apiBaseUrl

angular.
module('core.rent')
    .factory('Product', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/product/:objectId',
            {
                objectId: '@id'
            }
        )
    }])
    .factory('Part', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/part/:objectId',
            {
                objectId: '@id'
            }
        )
    }])
    .factory('ShopCart', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/cart/',
            {},
            {
                save: {
                    method: 'PUT'
                },
                update: {
                    method: 'POST'
                }
            }
        )
    }])
    .factory('Order', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/order/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('OrdersList', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/orders-list/',
            {}
        )
    }])
    .factory('Invoices', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/invoices-list/',
            {}
        )
    }])
    .factory('ProductsList', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/products-cart-list/',
            {}
        )
    }])
    .factory('DeliveryList', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/lk/api/delivery-list/',
            {}
        )
    }])
;